<template>
  <a-input-password
    v-bind="$attrs.item"
    v-model="modelList[name]"
    @change="(e)=>findEvent({e})"
    @pressEnter="(e)=>findEvent({e})"
  />
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import { Input } from "ant-design-vue";
export default {
  mixins: [formMixin],
  components: { [Input.name]: Input },
  props: {
    name: {},
    modelList: {},
    funcList: {},
  },
};
</script>
